import React from 'react'
import MediaQuery from 'react-responsive'
import mediaSize from '../../../../constants/mediaSize'

import styles from './styles.module.scss'

export default () => (
  <div className={styles.wrap}>
    <div className="base-layout">
      <div className={styles.content}>
        <div className={styles.column}>
          <MediaQuery minWidth={mediaSize.maxPhoneSize}>
            <img
              alt="dashes"
              src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/home/advantages/dashes.svg`}
              className={styles.dashes}
              width={288}
              height={170}
            />
          </MediaQuery>
          <div className={styles.card}>
            <h3 className={styles.cardTitle}>
              { 'Безопасная сделка' }
            </h3>
            <p className={styles.cardText}>
              { 'Незаменимый инструмент для расчётов между пользователями. '
                + 'Средства резервируются и\u00A0выплачиваются после выполнения '
                + 'условий сервиса, продавца или исполнителя.'}
            </p>
          </div>
          <div className={styles.creditCardWrap}>
            <i className={styles.creditCardBack} />
            <img
              alt="card"
              src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/home/advantages/card.webp`}
              className={styles.creditCard}
            />
            <img
              alt="cardFront"
              src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/home/advantages/card_front.svg`}
              className={styles.creditCardFront}
            />
          </div>
          <div className={styles.card}>
            <h3 className={styles.cardTitle}>
              { 'Быстрые выплаты' }
            </h3>
            <p className={styles.cardText}>
              { 'Вам доступны расширенные лимиты выплат. Достаточно привязать банковскую карту '
                + 'или номер мобильного телефона продавца. Деньги поступят крайне быстро.' }
            </p>
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.card}>
            <img
              alt="tie"
              src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/home/advantages/tie.svg`}
              className={styles.tie}
            />
            <h3 className={styles.cardTitle}>
              { 'Единый договор' }
            </h3>
            <p className={styles.cardText}>
              { 'Вам не придётся подписывать множество документов и\u00A0заполнять кипу бумаг. '
                + 'Простое соглашение и\u00A0понятная оферта сократят время подключения до\u00A0минимума.' }
            </p>
          </div>
          <div className={styles.card}>
            <h3 className={styles.cardTitle}>
              { 'Защита от фрода' }
            </h3>
            <p className={styles.cardText}>
              { 'Ловим мошенников ещё до совершения ими платежа. '
                + 'Искусственный интеллект эффективно выявляет и\u00A0блокирует любую подозрительную активность'
                + ' нежелательных клиентов.' }
            </p>
          </div>
          <div className={styles.card}>
            <h3 className={styles.cardTitle}>
              { 'Удобные платежи' }
            </h3>
            <p className={styles.cardText}>
              { 'Разместите платёжную форму или используйте наше API. '
                + 'Можно оплатить QR-кодом, банковской картой или электронным кошельком.' }
            </p>
            <div className={styles.cardImagesWrap}>
              <i className="i_visa" />
              <MediaQuery minWidth={mediaSize.maxPhoneSize}>
                <i className="i_mir" />
              </MediaQuery>
              <i className="i_mastercard" />
              <i className="i_plus" />
            </div>
          </div>
          <MediaQuery minWidth={mediaSize.maxPhoneSize}>
            {/*
            <img alt="bubbles" src={bubbles} className={styles.bubbles} />
            */}
            <img
              alt="blobBig"
              src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/home/advantages/blob_big.png`}
              className={styles.blobBig}
              width={195}
              height={194}
            />
            <img
              alt="blobSmall"
              src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/home/advantages/blob_small.png`}
              className={styles.blobSmall}
              width={115}
              height={112}
            />
          </MediaQuery>
        </div>
      </div>
    </div>
  </div>
)
